import React from 'react'
import styled from '@emotion/styled'
import { FusionColor, L1ReasonableButton } from '@fusion-advantage/formrender'
import { faReply } from '@fortawesome/pro-solid-svg-icons'

interface ScanOverlayRootProps {
	visible: boolean
}

const ScanOverlayRoot = styled.div<ScanOverlayRootProps>(({visible}) => ({
	position: 'fixed',
	top: 0,
	left: 0,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100vw',
	height: '100vh',
	pointerEvents: visible ? 'auto' : 'none',
	opacity: visible ? 1 : 0,
	transition: 'all 0.5 ease-in-out',
}))

const ScanTargetContainer = styled.div({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
})

const ScanTarget = styled.div(({theme}) => ({
	border: `1px solid ${theme.colors.lines}`,
	borderRadius: theme.borderRadius,
	width: `62vw`,
	height: `38vh`,
}))

const ScanActionsContainer = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	paddingBottom: theme.spacing(4),
}))

interface ScanOverlayProps {
	onCancelClick?: (e: React.MouseEvent) => void
	visible?: boolean
}

const ScanOverlay = ({onCancelClick, visible = true}: ScanOverlayProps) => {
	return (
		<ScanOverlayRoot visible={visible}>
			<ScanTargetContainer>
				<ScanTarget />
			</ScanTargetContainer>
			<ScanActionsContainer>
				<L1ReasonableButton
					color={FusionColor.White}
					icon={faReply}
					label="Cancel"
					onClick={onCancelClick}
				/>
			</ScanActionsContainer>
		</ScanOverlayRoot>
	)
}

export default ScanOverlay
